import { more, moreRotated } from "assets/icons/index";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { NEWS_DETAILS_PATH } from "Routes/paths";

interface NewsCardProps {
  data?: any;
}

const NewsCard = ({ data }: NewsCardProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="w-full h-full p-[5px] flex flex-col gap-2 shadow-shadow_main hover:shadow-shadow_hover duration-300 rounded-[20px]">
      {/* image  *******************************/}
      <div className="w-full max-h-[200px] bg-first_color rounded-[20px]">
        <img
          className="w-full max-h-[200px] rounded-[20px]"
          src={data?.thumbnail_url}
          alt=""
        />
      </div>

      {/* details  *****************************/}
      <div className="p-[5px] h-full flex flex-col justify-between">
        {/* title  */}
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[16px] text-second_color max-h-[45px] line-clamp-2 text-ellipsis`}
        >
          {i18n.language === "en" ? data?.title_en : data?.title_ar}
        </p>

        {/* news date  */}
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[400] text-[12px] text-[#808184]`}
        >
          {data?.created_on.slice(0, 10)}
        </p>

        {/* description  */}
        <p
          dangerouslySetInnerHTML={{
            __html: `${
              i18n.language === "en"
                ? data?.description_en
                : data?.description_ar
            }`,
          }}
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[400] text-[12px] max-h-[45px] line-clamp-2 text-ellipsis`}
        >
          {/* {data?.description_en} */}
        </p>
        <p
          onClick={() => navigate(`${NEWS_DETAILS_PATH}/${data?.id}`)}
          className={`flex items-center gap-3 font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[15px] text-first_color cursor-pointer group`}
        >
          {t("Read More")}{" "}
          {i18n.language === "en" ? (
            <img
              className="group-hover:animate-[moveRight_1s_ease-in-out_infinite]"
              src={more}
              alt=""
            />
          ) : (
            <img
              className="group-hover:animate-[moveLeft_1s_ease-in-out_infinite]"
              src={moreRotated}
              alt=""
            />
          )}
        </p>
      </div>
    </div>
  );
};

export default NewsCard;
